import PropTypes from 'prop-types';
import React from 'react';

export const ARTICLES_CARD_PROPTYPES = {
    /**
     * title
     * */
    title: PropTypes.string,
    /**
     * article card image
     * */
    image: PropTypes.string,
    /**
     * url
     * */
    contentUrl: PropTypes.string,
    /**
     * description
     * */
    description: PropTypes.string,
};

export const ARTICLES_CARD_PROPTYPES2 = {
    /**
     * title
     * */
    title: PropTypes.string,
    /**
     *article card wink
     * */
    wink: PropTypes.string,
    /**
     * image for image
     * */
    contentImage: PropTypes.shape({
        src: PropTypes.string,
        alt: PropTypes.string,
    }),
    /**
     * url
     * */
    contentUrl: PropTypes.string,
    /**
     * description for card
     * */
    description: PropTypes.string,
};

export const RESEARCH_LINK_PROPTYPES = {
    /**
     * type of card
     * */
    type: PropTypes.string,
    /**
     * wink
     * */
    wink: PropTypes.string,
    /**
     * title of card
     * */
    title: PropTypes.string,
    /**
     * url
     * */
    url: PropTypes.string,
};
